import Vue from 'vue'
import Router from 'vue-router'
import CustomRateList from '@/components/CustomRateList/CustomRateList'
import ChemicalList from '@/components/ChemicalList/ChemicalList'
import ChemicalEditForm from '@/components/ChemicalEditForm/ChemicalEditForm'
import FertilizerList from '@/components/FertilizerList/FertilizerList'
import FertilizerEditForm from '@/components/FertilizerEditForm/FertilizerEditForm'
import CropList from '@/components/CropList/CropList'
import CropShow from '@/components/CropShow/CropShow'
import CropEditForm from '@/components/CropEditForm/CropEditForm'
import CommodityList from '@/components/CommodityList/CommodityList'
import CommodityEditForm from '@/components/CommodityEditForm/CommodityEditForm'
import OtherIncomeList from '@/components/OtherIncomeList/OtherIncomeList'
import OtherIncomeEditForm from '@/components/OtherIncomeEditForm/OtherIncomeEditForm'
import CustomRateEditForm from '@/components/CustomRateEditForm/CustomRateEditForm'
import ConvertUnitList from '@/components/ConvertUnitList'
import SeedList from '@/components/SeedList/SeedList'
import SeedEditForm from '@/components/SeedEditForm/SeedEditForm'
import IrrigationList from '@/components/IrrigationList/IrrigationList'
import IrrigationEditForm from '@/components/IrrigationEditForm/IrrigationEditForm'
import OtherExpenseList from '@/components/OtherExpenseList/OtherExpenseList'
import OtherExpenseEditForm from '@/components/OtherExpenseEditForm/OtherExpenseEditForm'

import SignInForm from '@/components/SignInForm/SignInForm'
import SignUpForm from '@/components/SignUpForm/SignUpForm'

import CheckEmailPage from '@/components/CheckEmailPage/CheckEmailPage'
import VerifyEmailForm from '@/components/VerifyEmailForm/VerifyEmailForm'
import SubscriptionForm from '@/components/SubscriptionForm/SubscriptionForm'
import BillingAccountIssue from '@/components/BillingAccountIssue/BillingAccountIssue'

// needed to check if user is logged in
import store from '../store'

Vue.use(Router)

const requireSignedInUser = (to, from, next) => {
  if (!store.getters.signedIn) {
    next('/sign-in')
  } else {
    next()
  }
}

export default new Router({
  routes: [
    {
      path: '/',
      name: 'RootRoute',
      component: CustomRateList
    },
    {
      path: '/custom-rates',
      name: 'CustomRateList',
      component: CustomRateList
    },
    {
      path: '/chemicals',
      name: 'ChemicalList',
      component: ChemicalList
    },
    {
      path: '/chemicals-edit/:id',
      name: 'ChemicalEditForm',
      component: ChemicalEditForm,
      props: true
    },
    {
      path: '/fertilizers',
      name: 'FertilizerList',
      component: FertilizerList
    },
    {
      path: '/fertilizers-edit/:id',
      name: 'FertilizerEditForm',
      component: FertilizerEditForm,
      props: true
    },
    {
      path: '/custom-rates-edit/:id',
      name: 'CustomRateEditForm',
      component: CustomRateEditForm,
      props: true
    },
    {
      path: '/seeds',
      name: 'SeedList',
      component: SeedList
    },
    {
      path: '/seeds-edit/:id',
      name: 'SeedEditForm',
      component: SeedEditForm,
      props: true
    },
    {
      path: '/irrigation',
      name: 'IrrigationList',
      component: IrrigationList
    },
    {
      path: '/other-income',
      name: 'OtherIncomeList',
      component: OtherIncomeList
    },
    {
      path: '/other-income-edit/:id',
      name: 'OtherIncomeEditForm',
      component: OtherIncomeEditForm,
      props: true
    },
    {
      path: '/other-expense',
      name: 'OtherExpenseList',
      component: OtherExpenseList
    },
    {
      path: '/other-expense-edit/:id',
      name: 'OtherExpenseEditForm',
      component: OtherExpenseEditForm,
      props: true
    },
    {
      path: '/irrigation-edit/:id',
      name: 'IrrigationEditForm',
      component: IrrigationEditForm,
      props: true
    },
    {
      path: '/crops',
      name: 'CropList',
      component: CropList
    },
    {
      path: '/crops-show/:cropId',
      name: 'CropShow',
      component: CropShow,
      props: true
    },
    {
      path: '/crops-edit/:id',
      name: 'CropEditForm',
      component: CropEditForm,
      props: true
    },
    {
      path: '/commodities',
      name: 'CommodityList',
      component: CommodityList
    },
    {
      path: '/commodities-edit/:id',
      name: 'CommodityEditForm',
      component: CommodityEditForm,
      props: true
    },
    {
      path: '/convert-units',
      name: 'ConvertUnitList',
      component: ConvertUnitList
    },
    {
      path: '/sign-in',
      name: 'SignIn',
      component: SignInForm
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUpForm
    },
    {
      path: '/check-email',
      name: 'CheckEmailPage',
      component: CheckEmailPage
    },
    {
      path: '/verify-email',
      name: 'VerifyEmailForm',
      component: VerifyEmailForm
    },
    {
      path: '/subscription',
      name: 'SubscriptionForm',
      component: SubscriptionForm,
      beforeEnter: requireSignedInUser
    },
    {
      path: '/billing-account-issue',
      name: 'BillingAccountIssue',
      component: BillingAccountIssue
    }
  ]
})
